import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageHiLite() {
    return (
        <div className="privacy-policy-container">
 <h1>तस्बीह धिक्र लाइट प्राइवेसी पॉलिसी</h1>
      <p>अंतिम अद्यतन: 31 जनवरी 2024</p>

      <h2>परिचय</h2>
      <p>तस्बीह धिक्र लाइट ऐप में आपका स्वागत है। यह गोपनीयता नीति आपको हमारे ऐप का उपयोग करते समय आपके डेटा के संबंध में हमारी प्रक्रियाओं के बारे में जानकारी देने के लिए है। इस ऐप में एकमात्र डेटा संग्रहण AdMob द्वारा किया जाता है, जो गूगल की विज्ञापन सेवा है, और हम सक्रिय रूप से कोई व्यक्तिगत डेटा नहीं एकत्र करते हैं।</p>

      <h2>1. आपके व्यक्तिगत डेटा का संग्रहण और उपयोग</h2>
      <h3>a. एकत्रित डेटा के प्रकार</h3>
      <h4>i. AdMob के माध्यम से डेटा उपयोग</h4>
      <p>हमारा ऐप AdMob का उपयोग करके विज्ञापन प्रदर्शित करता है। AdMob आपके IP पते, आपके डिवाइस की पहचानकर्ता और ऐप के उपयोग संबंधी जानकारी जैसे डेटा एकत्र कर सकता है। ये विवरण विज्ञापन अनुभव को सुधारने और वैयक्तिकृत करने के लिए उपयोग किए जाते हैं।</p>

      <h3>b. डेटा का उपयोग</h3>
      <p>AdMob द्वारा एकत्रित डेटा का उपयोग निम्नलिखित के लिए किया जाता है:</p>
      <ul>
        <li>ऐप के भीतर विज्ञापन प्रदान करना और व्यक्तिगत बनाना।</li>
        <li>प्रदर्शित विज्ञापनों की प्रभावशीलता का विश्लेषण करना।</li>
      </ul>

      <h3>c. उपयोगकर्ता नियंत्रण</h3>
      <p>आप अपने डिवाइस की सेटिंग्स के माध्यम से वैयक्तिकृत विज्ञापन के लिए अपने डेटा के उपयोग को नियंत्रित कर सकते हैं।</p>

      <h2>2. डेटा का स्थानांतरण</h2>
      <p>आपकी जानकारी को उन कंप्यूटरों पर स्थानांतरित और बनाए रखा जा सकता है जो आपके राज्य, प्रांत या देश के बाहर स्थित हैं, जहां डेटा सुरक्षा कानून अलग हो सकते हैं।</p>

      <h2>3. आपके व्यक्तिगत डेटा का प्रकटीकरण</h2>
      <p>AdMob द्वारा एकत्रित डेटा Google की गोपनीयता नीति और कानूनी आवश्यकताओं के अनुसार साझा किया जा सकता है।</p>

      <h2>4. आपके व्यक्तिगत डेटा की सुरक्षा</h2>
      <p>आपके डेटा की सुरक्षा हमारे लिए महत्वपूर्ण है। हालांकि, इंटरनेट पर कोई भी संचरण विधि या इलेक्ट्रॉनिक स्टोरेज विधि 100% सुरक्षित नहीं है।</p>

      <h2>5. अन्य साइटों के लिंक</h2>
      <p>हमारी सेवा में अन्य साइटों के लिंक शामिल हो सकते हैं। यदि आप किसी तृतीय-पक्ष लिंक पर क्लिक करते हैं, तो आप उस तृतीय पक्ष की साइट पर निर्देशित किए जाएंगे।</p>

      <h2>6. इस गोपनीयता नीति में परिवर्तन</h2>
      <p>हम समय-समय पर अपनी गोपनीयता नीति को अपडेट कर सकते हैं। हम आपको किसी भी परिवर्तन की सूचना इस पृष्ठ पर नई गोपनीयता नीति प्रकाशित करके देंगे।</p>

      <h2>7. हमसे संपर्क करें</h2>
      <p>यदि आपके पास इस गोपनीयता नीति के संबंध में कोई प्रश्न हैं, तो कृपया हमसे संपर्क करें।</p>

      <h2>उपयोगी लिंक्स</h2>
      <p><a href="https://policies.google.com/privacy">Google की गोपनीयता नीति</a></p>
    </div>
    );
}

export default PrivacyPolicyPageHiLite;
